import React from "react";
import { Card, CardContent, Box, Typography, Link } from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";
import { toAlignEnd } from "services/constants";
import { CustomButtonWithBorder } from "components/CustomComponents/CustomButton";
// import { CustomButton } from "components/CustomComponents";

const WarningCard = ({
  message = "Missing entries",
  linkText = "Click here",
  linkAction,
  onRerun,
  // neglectAndContinue,
  isLastWarning = false,
}) => {
  const [beforeLink, afterLink] = message.split(linkText);

  return (
    <Card
      variant="outlined"
      sx={{
        bgcolor: "#fefce8",
        borderColor: "#fef5b5",
      }}
    >
      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <WarningIcon
            sx={{
              width: 23,
              height: 23,
              color: "warning.main",
              fontSize: 20,
              flexShrink: 0,
              mt: 0.25,
            }}
          />
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              sx={{ color: "text.primary", paddingTop: 0.5 }}
            >
              {beforeLink}
              <Link
                component="button"
                onClick={linkAction}
                sx={{
                  color: "primary.main",
                  pl: 1,
                  pb: 0.3,
                  fontWeight: "medium",
                  textDecoration: "underline",
                  "&:hover": {
                    color: "primary.dark",
                  },
                }}
              >
                {linkText}
              </Link>
              {afterLink}
            </Typography>
            {isLastWarning && (
              <Box sx={{ ...toAlignEnd, mt: 1.5 }}>
                <CustomButtonWithBorder
                  actionName="Re run"
                  typeName="button"
                  actionFuntion={onRerun}
                />
                {/* <CustomButton
                  actionFuntion={neglectAndContinue}
                  actionName="Neglect & Continue"
                  typeName="submit"
                /> */}
              </Box>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default WarningCard;
